/**
 * Created by mqamhieh on 2/3/18.
 */
(function () {
    angular.module("rootApp", [
        'ui.router',
        'ngCookies',
        'ngMessages',
        'ngResource',
        'ngSanitize',
        'DispatcherModule',
        'color.picker',
        'ngMask',
        'ngFileUpload',
        'mgcrea.ngStrap',
        "harriApp.smartFields",
        'components',
        'directives',
    ]);
})();
